import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vodafoneziggo.webp';
import screenshot_target from '../../../images/letterfunnel/thomashelbo.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Thomas Helbo"
      firstname="Thomas"
      companyname="VodafoneZiggo"
      competition="KPN en Odido"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/thomashelbo.js